import config from '../config/app'
import axios from 'axios'

const VERSION = '/v2'
const PATH = 'trial-account'

const trialAccountAPI = {
  createAccount (fields) {
    return new Promise((resolve, reject) => {
      axios.post(config.server + VERSION + '/' + PATH + '/create', fields).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  }
}

export default trialAccountAPI



// WEBPACK FOOTER //
// ./src/api/trialAccount.js